import useAppStore from "src/stores/appStore";
import { previewDraftBuildResponseSelector } from "src/stores/selectors/previewSelectors";
import { BUILD_STATUSES } from "@consts";
import { useDraft } from "src/queries/hooks/assistants";
import { isFetchingValidationResultsSelector, hasFetchedInitialValidationResultsSelector, hasValidationErrors } from "src/stores/selectors/collectionsSelectors";

const useActionButton = () => {
  const buildDraftResponse = useAppStore(previewDraftBuildResponseSelector);
  const isFetchingValidationResults = useAppStore(isFetchingValidationResultsSelector);
  const hasFetchedInitialValidationResults = useAppStore(hasFetchedInitialValidationResultsSelector);
  const hasAssistantValidationErrors = useAppStore(hasValidationErrors);
  const { data: draft, isLoading: isDraftLoading } = useDraft();

  const showLoadingPlaceholder = isDraftLoading ||
        (draft && !buildDraftResponse) ||
        (isFetchingValidationResults && !hasFetchedInitialValidationResults);

  const isBuildDisplayed = !draft ||
        hasAssistantValidationErrors ||
        buildDraftResponse?.status === "" ||
        buildDraftResponse?.status === BUILD_STATUSES.PENDING ||
        buildDraftResponse?.status === BUILD_STATUSES.KG_UPDATE ||
        buildDraftResponse?.status === BUILD_STATUSES.CHANGED ||
        buildDraftResponse?.status === BUILD_STATUSES.EXPIRED ||
        buildDraftResponse?.status === BUILD_STATUSES.TERMINATED ||
        buildDraftResponse?.status === BUILD_STATUSES.NOT_FOUND;

  return {
    showLoadingPlaceholder,
    isBuildDisplayed
  };
};

export default useActionButton;
